class CartCarousel extends SearchspringCarouselHandler {
  constructor() {
    super([], "home", null, "product-card");

    this.availabilityCache = new Map();
  }

  getCarouselOptions() {
    return {
      type: "slide",
      gap: "0.8rem",
      padding: { left: "2.4rem", right: "2.4rem" },
      trimSpace: true,
      free: true,
      pagination: false,
      breakpoints: {
        750: {
          padding: { left: "16px", right: "16px" },
        },
      },
    };
  }

  getProductCards(results) {
    const uniqueProducts = [];
    const seenIds = new Set();

    const allProducts = [...results];

    for (const product of allProducts) {
      const productId = product.id || product.mappings?.core?.uid;
      if (!seenIds.has(productId)) {
        seenIds.add(productId);
        uniqueProducts.push(product);
      }
    }

    const wrappers = super.getProductCards(uniqueProducts);

    wrappers.forEach((li) => {
      const card = li.querySelector(this.productCardComponent) || li.firstElementChild;
      if (!card) return;

      if (card.setAvailabilityCache) {
        card.setAvailabilityCache(this.availabilityCache);
      }

      card.dataset.showBrand = card.dataset.showBrand ?? "true";
      card.dataset.showMsrp = card.dataset.showMsrp ?? "true";
      card.dataset.showQuickAdd = card.dataset.showQuickAdd ?? "true";
      card.dataset.quickAddSection = card.dataset.quickAddSection ?? "cart-carousel";
      card.dataset.badgeText = card.dataset.badgeText ?? "SALE";
      card.dataset.badgeColor = card.dataset.badgeColor ?? "#E41613";
      card.dataset.currencySymbol = card.dataset.currencySymbol ?? "£";
      card.dataset.ns = card.dataset.ns ?? "wiro";
    });

    return wrappers;
  }

  getDomString(results) {
    const svg_arrow = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="tw-fill-black group-disabled:tw-fill-[#A1A1A1]" d="M2.66406 8L2.31051 7.64645L1.95696 8L2.31051 8.35355L2.66406 8ZM12.6641 8.5C12.9402 8.5 13.1641 8.27614 13.1641 8C13.1641 7.72386 12.9402 7.5 12.6641 7.5V8V8.5ZM6.66406 4L6.31051 3.64645L2.31051 7.64645L2.66406 8L3.01762 8.35355L7.01762 4.35355L6.66406 4ZM2.66406 8L2.31051 8.35355L6.31051 12.3536L6.66406 12L7.01762 11.6464L3.01762 7.64645L2.66406 8ZM2.66406 8V8.5H12.6641V8V7.5H2.66406V8Z" fill="black"/>
  </svg>`;

    if (!results.length) {
      return `<p class="tw-text-gray-500 tw-p-4">No products found</p>`;
    }

    return `
      <section class="splide" aria-labelledby="carousel-heading">
        <div class="tw-flex tw-gap-2 tw-justify-between tw-px-4 sm:tw-px-6 tw-items-center tw-py-4 tw-border-t tw-border-t-[#E7E7E7]">
          <p class="h5 tw-uppercase">You may also like</p>
          <div class="splide__arrows tw-relative tw-flex tw-gap-2">
            <button class="disabled:tw-border-[#A1A1A1] tw-border-black tw-group splide__arrow--prev !tw-relative !tw-left-0 tw-p-2 tw-border tw-rotate-180 tw-rounded-[4px] enabled:hover:tw-scale-105 enabled:hover:tw-border-[#3C3C3C]">
              ${svg_arrow}
            </button>
            <button class="disabled:tw-border-[#A1A1A1] tw-border-black tw-group splide__arrow--next !tw-relative !tw-right-0 tw-p-2 tw-border tw-rotate-180 tw-rounded-[4px] enabled:hover:tw-scale-105 enabled:hover:tw-border-[#3C3C3C]">
              ${svg_arrow}
            </button>
         </div>
        </div>
        <div class="splide__track">
          <ul class="splide__list [&_li]:sm:tw-max-w-[200px] [&_li]:tw-max-w-[168px]" data-card-container>
          </ul>
        </div>
      </section>
    `;
  }
}

if (!customElements.get("cart-carousel")) {
  customElements.define("cart-carousel", CartCarousel);
}
